export default {
  tables: [
    {
      action: 'create',
      table: 'applications',
      indexes: [
        {
          name: 'hostnames',
          multi: true
        },
        'organizationId'
      ]
    },
    {
      action: 'create',
      table: 'link_applications_users',
      indexes: [
        'applicationId',
        'userId'
      ],
      compoundIndexes: [
        {
          name: 'link_application_users',
          indexes: ['applicationId', 'userId']
        }
      ]
    },
    {
      action: 'create',
      table: 'application_secrets',
      indexes: [
        'applicationId',
      ],
    },
  ]
}
